import React, { useState } from "react";
import { Form, Input } from "antd";
import axios from "axios";
import { KeyOutlined, MailOutlined, SafetyOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  SuccessMessage,
  ErrorMessage,
} from "../../components/Messages/messages";
import { Loading } from "../../components/Loading/Loading";
import "./Auth.css";
import API_BASE_URL from "../../config";

export const ResetPassword = (props) => {
  const [loading, setLoading] = useState(false);
  const [resetData, setResetData] = useState({
    email: props.location.state?.email || "",
    token: "",
    newPassword: "",
    confirmPassword: "",
  });

  const { email, token, newPassword } = resetData;

  const handleChange = (e) => {
    setResetData({
      ...resetData,
      [e.target.name]: e.target.value,
    });
  };

  const onFinish = async (e) => {
    window.scrollTo(0, 0);
    setLoading(true);
    await axios
      .post(`${API_BASE_URL}/api/users/reset-password`, {
        email,
        token,
        newPassword,
      })
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          SuccessMessage(res.data.successMessage);
          setTimeout(() => {
            props.history.push("/login");
          }, 2000);
        } else if (res.status === 400) {
          ErrorMessage(res.data.errorMessage);
        } else {
          ErrorMessage(res.data.errorMessage);
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.data) {
          ErrorMessage(error.response.data.errorMessage);
        } else {
          ErrorMessage("An error occurred. Please try again.");
        }
      });
  };

  return (
    <div>
      <Helmet>
        <title>Reset Password</title>
      </Helmet>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="auth">
            <div className="auth-inner text-center inherit-background">
              <div className="header">
                <Link className="apply-teko" to="/">
                  Cost Advisor
                </Link>
                <h3 className="apply-teko"> Reset Password </h3>
                <p className="text-white mt-3">
                  Enter the code sent to your email and your new password.
                </p>
              </div>
              <Form
                name="basic"
                initialValues={{ remember: true, email: email }}
                onFinish={onFinish}
                className="p-4 custom-form"
              >
                <div className="floating-label-group input-box">
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        type: "email",
                        message:
                          "The provided input is not a valid email address.",
                      },
                      {
                        required: true,
                        message: "Please enter your email.",
                      },
                    ]}
                  >
                    <Input
                      name="email"
                      onChange={handleChange}
                      size="small"
                      placeholder="Email"
                      prefix={<MailOutlined />}
                      value={email}
                    />
                  </Form.Item>
                </div>
                <div className="floating-label-group input-box">
                  <Form.Item
                    name="token"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the reset code.",
                      },
                      {
                        len: 6,
                        message: "Reset code must be 6 digits.",
                      },
                    ]}
                  >
                    <Input
                      name="token"
                      onChange={handleChange}
                      size="small"
                      placeholder="Reset Code (6 digits)"
                      prefix={<SafetyOutlined />}
                      maxLength={6}
                    />
                  </Form.Item>
                </div>
                <div className="floating-label-group input-box">
                  <Form.Item
                    name="newPassword"
                    rules={[
                      {
                        required: true,
                        message: "Please input your new password.",
                      },
                      {
                        min: 6,
                        message: "Password must be at least 6 characters.",
                      },
                    ]}
                    hasFeedback
                  >
                    <Input.Password
                      type="password"
                      name="newPassword"
                      onChange={handleChange}
                      size="small"
                      placeholder="New Password"
                      prefix={<KeyOutlined />}
                    />
                  </Form.Item>
                </div>
                <div className="floating-label-group input-box">
                  <Form.Item
                    name="confirmPassword"
                    dependencies={["newPassword"]}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Please confirm your password.",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("newPassword") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("Passwords don't match.")
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      name="confirmPassword"
                      onChange={handleChange}
                      size="small"
                      placeholder="Confirm New Password"
                      prefix={<KeyOutlined />}
                    />
                  </Form.Item>
                </div>
                <div className="submit-btn-container">
                  <button
                    type="submit"
                    className="btn my-2 mt-3 mb-5 signup-btn"
                  >
                    Reset Password
                  </button>
                </div>
              </Form>
              <div>
                <p className="custom-form">
                  Remember your password?
                  <br></br>
                  <Link to="/login" className="pass">
                    Back to Login
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
